(function(){
	'use strict';

  angular
    .module('app.products')
    .config(routes);

  function routes($stateProvider) {
  	$stateProvider
  		.state('product', {
  			url: '/produtos',
  			templateUrl: 'products/layouts/product.template.html',
  			controller: 'ProductController',
  			controllerAs: 'vm',
  			parent: 'main'
  		})
		.state('productCategory', {
  			url: '/produtos/categoria/{slug}',
  			templateUrl: 'products/layouts/productCategory.template.html',
  			controller: 'ProductCategoryController',
  			controllerAs: 'vm',
  			parent: 'main'
  		})
		.state('productCustom', {
			url: '/produtos/personalizar',
			templateUrl: 'products/layouts/productCustom.template.html',
			controller: 'ProductCustomController',
			controllerAs: 'vm',
			parent: 'main'
		})
		.state('productDetails', {
			url: '/produtos/{slug}',
			templateUrl: 'products/layouts/productDetails.template.html',
			controller: 'ProductDetailsController',
			controllerAs: 'vm',
			parent: 'main'
		})
		.state('productCustomDetails', {
			url: '/produtos/personalizar/{id}',
			templateUrl: 'products/layouts/productCustomDetails.template.html',
			controller: 'ProductCustomDetailsController',
			controllerAs: 'vm',
			parent: 'main'
		})
  	}

})();
